import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

/**
 * A single reusable layout for the two legal pages so they share the same
 * calm, minimal typography and eyebrow header pattern.
 */
export function LegalLayout({ eyebrow, title, updated, children }) {
  return (
    <div className="mx-auto max-w-2xl p-4 md:p-8">
      <Link
        to="/"
        data-testid="legal-back-link"
        className="mono inline-flex items-center gap-1.5 text-[10px] uppercase tracking-[0.25em] text-muted-foreground hover:text-foreground transition-colors"
      >
        <ArrowLeft size={12} /> Back
      </Link>

      <div className="mt-6 border border-border">
        <div className="border-b border-border p-6 md:p-8">
          <p className="mono text-[10px] uppercase tracking-[0.3em] text-[#C9A85F]">
            → {eyebrow}
          </p>
          <h1 className="mt-2 text-4xl leading-tight tracking-tight md:text-5xl">
            {title}
          </h1>
          <p className="mono mt-3 text-[10px] uppercase tracking-widest text-muted-foreground">
            Last updated: {updated}
          </p>
        </div>
        <article className="p-6 md:p-8 space-y-6 text-[15px] leading-relaxed">
          {children}
        </article>
      </div>
    </div>
  );
}

export function LegalSection({ title, children }) {
  return (
    <section>
      <h2 className="text-lg font-semibold tracking-tight">{title}</h2>
      <div className="mt-2 space-y-2 text-muted-foreground">{children}</div>
    </section>
  );
}
